import '../modalWrapper.scss';
import './invalidate.scss';

import Device from '../../../../assets/images/icons/device.png';

import React, { FunctionComponent } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../features';
import { setModalSignInUp } from '../../../../store/AppSlice';
import { modalTypeEnum } from '../../../../types/modal';
import { fetchNposList, getInvalidateNposLoadingStatus, getInvalidateNposMessage, getInvalidateNposStatus, getNposInvalidadeId, invalidateNpos, setInvalidateNposStatus } from '../../../../store/NposSlice';
import { TRKLoader } from '../../loader/loader';
import { getModalLoaderStatus, setModalLoaderStatus } from '../../../../store/LoaderSlice';

export const ModalInvalideNpos: FunctionComponent = () => {

    const dispatch = useAppDispatch();
    
    const loading = useAppSelector(getModalLoaderStatus);
    const npos_id = useAppSelector(getNposInvalidadeId);

    const npos_invalide_status  = useAppSelector(getInvalidateNposStatus);
    const npos_loading_status   = useAppSelector(getInvalidateNposLoadingStatus);

    const handleClick = (cat:boolean) => { 
        if (!loading && cat) dispatch(setModalSignInUp(modalTypeEnum.none));
        if (!loading && !cat) {
            dispatch(setModalLoaderStatus(true));
            dispatch(invalidateNpos(npos_id));
        }
    }

    if (npos_loading_status) return <ModalInvalideNposLoading />
    if (npos_invalide_status) return <ModalInvalideNposStatus />

    return (
        <div className="modal modal-invalidate-npos">
            {npos_id ? (
                <div className="invalidate-wrapper first">
                    <img src={Device} alt="" />
                    <p className='hash'>
                        {npos_id}
                    </p>
                    <p>
                        Deseja <b>revogar</b> todos acessos desse NPoS?
                    </p>
                    <div className="flex">
                        <button 
                            onClick={() => { handleClick(true) }} 
                            className='btn btn-cancel'>
                            Cancelar
                        </button>
                        <button 
                            onClick={() => { handleClick(false) }} 
                            className='btn btn-continue'>
                            Revogar
                        </button>
                    </div>
                </div>
            ) : (
                <TRKLoader />
            )}
        </div>
    )
}

export const ModalInvalideNposLoading: FunctionComponent = () => {
    return (
        <div className="modal modal-invalidate-npos processando">
            <TRKLoader />
        </div>
    )
}

export const ModalInvalideNposStatus: FunctionComponent = () => {
    
    const dispatch = useAppDispatch();

    const npos_invalide_message = useAppSelector(getInvalidateNposMessage);

    const handleCLose = () => {
        dispatch(fetchNposList());
        dispatch(setInvalidateNposStatus(false));
        dispatch(setModalSignInUp(modalTypeEnum.none));
    }
    
    return (
        <div className="modal modal-invalidate-npos finish">
            <img src={Device} alt="" />
            <h1> {npos_invalide_message.message} </h1>
            <button onClick={handleCLose} className="btn btn-neutral">
                {npos_invalide_message.code <= 300 ? 'OK' : "Fechar"}
            </button>
        </div>
    )
}